import ExpandableTable from '../../components/Tables/ExpandableTable';
import { totalReportColumns } from '../../modules/Reports/columns';
import EmptyDataBlock from '../../modules/Reports/EmptyDataBlock';
import Loader from '../../components/Loader/Loader';
import { useReportTotal } from './useReportTotal';
import { sortByName } from '../../constants/sort-order';

const ReportTotal = () => {
  const {
    expandByDefault,
    expandedRowStyle,
    goToEmployee,
    isLoading,
    setExpandedRowId,
    sortedTotalReportTableData,
    t,
    tableRef,
  } = useReportTotal();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      {sortedTotalReportTableData?.length ? (
        <ExpandableTable
          columns={totalReportColumns(t)}
          data={sortedTotalReportTableData}
          expandedRowId={expandByDefault}
          expandedRowKey='expandedEmployee'
          expandedRowStyle={expandedRowStyle}
          onRowClick={goToEmployee}
          ref={tableRef}
          rowDepth={0}
          setExpandedRowId={setExpandedRowId}
          sortOrder={sortByName}
          tableName='total-reports-list'
        />
      ) : (
        <EmptyDataBlock />
      )}
    </>
  );
};

export default ReportTotal;
